import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import getElementByQuerySelector from 'commons/getElementByQuerySelector';
const FormikFirstErrorFieldFocusOnSubmit = t0 => {
  const $ = _c(8);
  const {
    formFieldRefs,
    arrayFields: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const arrayFields = t2;
  const {
    errors,
    isSubmitting
  } = useFormikContext();
  let t3;
  let t4;
  if ($[2] !== arrayFields || $[3] !== errors || $[4] !== formFieldRefs || $[5] !== isSubmitting) {
    t3 = () => {
      if (!isSubmitting) {
        return;
      }
      const formFields = Object.keys(errors);
      let finalArrayKeyName = "";
      let callNestedElement = false;
      const firstErrorField = formFields.find(fieldName => {
        if (arrayFields.includes(fieldName)) {
          errors[fieldName].forEach((fieldValue, index) => {
            const fieldKeys = Object.keys(fieldValue || {});
            const keyName = fieldKeys.find(fieldKey => !!fieldValue[fieldKey]);
            if (keyName && !finalArrayKeyName) {
              finalArrayKeyName = `${fieldName}${index}${keyName}`;
              callNestedElement = true;
            }
          });
          return true;
        }
        return !!errors[fieldName];
      });
      const finalFirstErrorField = finalArrayKeyName || firstErrorField;
      if (finalFirstErrorField && (formFieldRefs?.[finalFirstErrorField]?.current || callNestedElement)) {
        if (callNestedElement) {
          const el = getElementByQuerySelector(`.${finalFirstErrorField}`);
          if (el) {
            el.focus();
          }
        } else {
          formFieldRefs[finalFirstErrorField].current.focus();
        }
      }
    };
    t4 = [arrayFields, errors, formFieldRefs, isSubmitting];
    $[2] = arrayFields;
    $[3] = errors;
    $[4] = formFieldRefs;
    $[5] = isSubmitting;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  return null;
};
FormikFirstErrorFieldFocusOnSubmit.propTypes = {
  arrayFields: PropTypes.arrayOf(PropTypes.string),
  formFieldRefs: PropTypes.object
};
export default FormikFirstErrorFieldFocusOnSubmit;